import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-privacy-and-policy',
  templateUrl: './privacy-and-policy.component.html',
  styleUrls: ['./privacy-and-policy.component.scss'],
})
export class PrivacyAndPolicyComponent implements OnInit {
  ngOnInit(): void { }

  toggleSubList() {
    this.subListOpen = !this.subListOpen;
  }
  @Input() visible = false; // Use this to control modal visibility from parent

  subListOpen = true;

  navItems = [
    {
      id: 'privacy1',
      index: '1',
      title: 'Information We Collect',
      content: `
        <p class="page-text mb-1">We collect information directly from you when you:</p>
        <div class="list-container mb-2">
          <p class="list-item page-text"><strong>Register an Account:</strong> Name, email, phone number, company name, and password.</p>
          <p class="list-item page-text"><strong>Make a Purchase:</strong> Billing details (e.g., address, payment details) are securely processed via third-party gateways. We shall not store any payment details with us.</p>
          <p class="list-item page-text"><strong>Communicate with Us:</strong> Information you provide during customer support interactions or when responding to surveys.</p>
        </div>
        <p class="page-text mb-1"><strong>Information We Collect Automatically</strong></p>
        <p class="page-text mb-2">When you use TripMeld, we collect certain information automatically:</p>
        <div class="list-container mb-2">
          <p class="list-item page-text"><strong>Usage Data:</strong> Actions you take within the platform, including features accessed, navigation activity, and session durations.</p>
          <p class="list-item page-text"><strong>IP Address, Device Info:</strong> IP address, browser type, operating system, and device identifiers.</p>
          <p class="list-item page-text"><strong>Cookies and Tracking:</strong> Data stored using cookies or similar technologies.</p>
        </div>
        <p class="page-text mb-1"><strong>Information From Third Parties</strong></p>
        <p class="page-text">We may receive information about you from:</p>
        <div class="list-container">
          <p class="list-item page-text"><strong>Referral Partners:</strong> Contact information provided by resellers or affiliates.</p>
          <p class="list-item page-text"><strong>Social Media:</strong> Public data from your interactions with our social media accounts.</p>
        </div>`
    },
    {
      id: 'privacy2',
      index: '2',
      title: 'How We Use Your Information',
      content: `
        <p class="page-text">We use your information to:</p>
        <div class="list-container">
          <p class="list-item page-text"><strong>Operate and Improve TripMeld:</strong> Manage accounts, enable features, and optimize performance.</p>
          <p class="list-item page-text"><strong>Process Transactions:</strong> Ensure secure payment processing and manage subscriptions.</p>
          <p class="list-item page-text"><strong>Communicate With You:</strong> Send important updates, promotional emails, and feedback requests.</p>
          <p class="list-item page-text"><strong>Ensure Security:</strong> Detect, prevent, and address fraud, misuse, or unauthorized access.</p>
          <p class="list-item page-text"><strong>Comply With Legal Obligations:</strong> Meet applicable laws and respond to lawful requests.</p>
        </div>`
    },
    {
      id: 'privacy3',
      index: '3',
      title: 'How We Share Your Information',
      content: `
        <p class="page-text mb-1"><strong>3.1 Service Providers</strong></p>
        <p class="page-text">We share your data with trusted third-party vendors for:</p>
        <div class="list-container mb-2">
          <p class="list-item page-text">Payment processing.</p>
          <p class="list-item page-text">Cloud hosting and data storage.</p>
          <p class="list-item page-text">Analytics to improve our services.</p>
          <p class="list-item page-text">Third party vendors who can give business.</p>
        </div>
        <p class="page-text mb-1"><strong>3.2 Legal and Regulatory Compliance</strong></p>
        <p class="page-text">We may disclose your data to:</p>
        <div class="list-container mb-2">
          <p class="list-item page-text">Comply with applicable laws, regulations, or legal processes.</p>
          <p class="list-item page-text">Protect our rights, users, or the public in cases of fraud or security risks.</p>
        </div>
        <p class="page-text mb-1"><strong>3.3 Business Transfers</strong></p>
        <p class="page-text">In the event of a merger, acquisition, or sale of assets, your information may be transferred to the involved parties.</p>`
    },
    // Continue adding the other sections in a similar way:
    {
      id: 'privacy4',
      index: '4',
      title: 'Data Retention',
      content: `
        <p class="page-text">We retain your personal information only for as long as necessary to fulfil the purposes outlined in this Privacy Policy, unless a longer retention period is required by law. When we no longer have a legitimate need to process your information, we will delete or anonymize your information from our active databases.</p>`
    },
    {
      id: 'privacy5',
      index: '5',
      title: 'Your Rights',
      content: `
        <p class="page-text">Depending on your location, you have the following rights regarding your personal data:</p>
        <div class="list-container mb-2">
          <p class="list-item page-text">Access and Correction: Request access to or correction of your data.</p>
          <p class="list-item page-text">Data Deletion: Request deletion of your personal information, subject to legal exceptions.</p>
          <p class="list-item page-text">Data Portability: Obtain a copy of your data in a structured, machine-readable format.</p>
          <p class="list-item page-text">Withdrawal of Consent: Revoke consent for data processing at any time.</p>
        </div>
        <p class="page-text">To exercise your rights, contact us at contact@tripmeld.com. We will respond within the timeframe required by applicable laws.</p>`
    },
    {
      id: 'privacy6',
      index: '6',
      title: 'Cookies and Tracking',
      content: `
        <p class="page-text">TripMeld uses cookies and similar technologies to:</p>
        <div class="list-container mb-2">
          <p class="list-item page-text">Enhance user experience.</p>
          <p class="list-item page-text">Track site usage and improve services.</p>
          <p class="list-item page-text">Deliver relevant marketing messages.</p>
        </div>
        <p class="page-text">You can manage cookie preferences through your browser settings, though disabling cookies may limit functionality.</p>`
    },
    {
      id: 'privacy7',
      index: '7',
      title: 'Data Security',
      content: `
        <p class="page-text">We employ industry-standard measures to protect your data, including:</p>
        <div class="list-container mb-2">
          <p class="list-item page-text"><strong>Encryption:</strong> Data is encrypted both in transit and at rest.</p>
          <p class="list-item page-text"><strong>Access Controls:</strong> Role-based permissions restrict access to sensitive information.</p>
          <p class="list-item page-text"><strong>Monitoring and Audits:</strong> Regular security audits and threat monitoring.</p>
        </div>
        <p class="page-text">While we take reasonable precautions, no system is completely secure, and we cannot guarantee the absolute security of your information.</p>`
    },
    {
      id: 'privacy8',
      index: '8',
      title: 'Data Breach Notification',
      content: `
        <p class="page-text">In the unlikely event of a data breach that affects your personal information:</p>
        <div class="list-container mb-2">
          <p class="list-item page-text">We will notify affected users and relevant regulatory authorities within 72 hours, as required by law.</p>
          <p class="list-item page-text">We will provide details about the breach, actions taken, and recommended steps to protect your information.</p>
        </div>`
    },
    {
      id: 'privacy9',
      index: '9',
      title: 'Children’s Privacy',
      content: `
        <p class="page-text">TripMeld is not intended for individuals under 18. We do not knowingly collect data from children. If you believe a child under 18 has provided personal information, contact us at contact@tripmeld.com, and we will delete the data.</p>`
    },
    {
      id: 'privacy10',
      index: '10',
      title: 'International Data Transfers',
      content: `
        <p class="page-text">Your data may be transferred to and processed in countries outside your own. Where applicable, we implement safeguards such as standard contractual clauses to ensure adequate protection.</p>`
    },
    {
      id: 'privacy11',
      index: '11',
      title: 'Policy Updates',
      content: `
        <p class="page-text">We may update this Privacy Policy periodically. We will notify you of significant changes via email or a notice on the platform. Continued use after changes constitutes acceptance.</p>`
    },
    {
      id: 'privacy12',
      index: '12',
      title: 'Contact Us',
      content: `
        <p class="page-text">For questions or concerns, please contact:</p>
        <p class="page-text"><strong>Email:</strong> contact@tripmeld.com</p>
        <p class="page-text"><strong>Address:</strong> 123 Reymould Street, Tech City, Country</p>`
    },
  ];

  constructor(private elementRef: ElementRef,
      private _modalController: ModalController

  ) { }



  scrollToSection(id: string) {
    const element = this.elementRef.nativeElement.querySelector(`#${id}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  closeModal() {
    this._modalController.dismiss();
  }
}
